module.exports = __webpack_public_path__ + "img/1487458579.2165dc67.jpg";